export interface WCPlayer {
  name: string;
  country: string;
}

export const GOLDEN_BOOT_PLAYERS: WCPlayer[] = [
  { name: 'Kylian Mbappé', country: 'France' },
  { name: 'Harry Kane', country: 'England' },
  { name: 'Lionel Messi', country: 'Argentina' },
  { name: 'Lautaro Martínez', country: 'Argentina' },
  { name: 'Vinícius Jr', country: 'Brazil' },
  { name: 'Rodrygo', country: 'Brazil' },
  { name: 'Richarlison', country: 'Brazil' },
  { name: 'Jhon Durán', country: 'Colombia' },
  { name: 'Luis Díaz', country: 'Colombia' },
  { name: 'Bukayo Saka', country: 'England' },
  { name: 'Phil Foden', country: 'England' },
  { name: 'Marcus Rashford', country: 'England' },
  { name: 'Antoine Griezmann', country: 'France' },
  { name: 'Florian Wirtz', country: 'Germany' },
  { name: 'Leroy Sané', country: 'Germany' },
  { name: 'Hirving Lozano', country: 'Mexico' },
  { name: 'Raúl Jiménez', country: 'Mexico' },
  { name: 'Youssef En-Nesyri', country: 'Morocco' },
  { name: 'Victor Osimhen', country: 'Nigeria' },
  { name: 'Cody Gakpo', country: 'Netherlands' },
  { name: 'Memphis Depay', country: 'Netherlands' },
  { name: 'Diogo Jota', country: 'Portugal' },
  { name: 'Rafael Leão', country: 'Portugal' },
  { name: 'Sadio Mané', country: 'Senegal' },
  { name: 'Son Heung-min', country: 'South Korea' },
  { name: 'Lamine Yamal', country: 'Spain' },
  { name: 'Álvaro Morata', country: 'Spain' },
  { name: 'Ferran Torres', country: 'Spain' },
  { name: 'Dani Olmo', country: 'Spain' },
  { name: 'Christian Pulisic', country: 'USA' },
  { name: 'Darwin Núñez', country: 'Uruguay' },
  { name: 'Robert Lewandowski', country: 'Poland' },
  { name: 'Romelu Lukaku', country: 'Belgium' },
];

export const GOLDEN_BALL_PLAYERS: WCPlayer[] = [
  { name: 'Kylian Mbappé', country: 'France' },
  { name: 'Jude Bellingham', country: 'England' },
  { name: 'Lionel Messi', country: 'Argentina' },
  { name: 'Enzo Fernández', country: 'Argentina' },
  { name: 'Lautaro Martínez', country: 'Argentina' },
  { name: 'Vinícius Jr', country: 'Brazil' },
  { name: 'Rodrygo', country: 'Brazil' },
  { name: 'Moisés Caicedo', country: 'Ecuador' },
  { name: 'Phil Foden', country: 'England' },
  { name: 'Bukayo Saka', country: 'England' },
  { name: 'Harry Kane', country: 'England' },
  { name: 'Antoine Griezmann', country: 'France' },
  { name: 'Florian Wirtz', country: 'Germany' },
  { name: 'Jamal Musiala', country: 'Germany' },
  { name: 'Achraf Hakimi', country: 'Morocco' },
  { name: 'Cody Gakpo', country: 'Netherlands' },
  { name: 'Bernardo Silva', country: 'Portugal' },
  { name: 'Bruno Fernandes', country: 'Portugal' },
  { name: 'Son Heung-min', country: 'South Korea' },
  { name: 'Pedri', country: 'Spain' },
  { name: 'Rodri', country: 'Spain' },
  { name: 'Lamine Yamal', country: 'Spain' },
  { name: 'Gavi', country: 'Spain' },
  { name: 'Dani Olmo', country: 'Spain' },
  { name: 'Christian Pulisic', country: 'USA' },
  { name: 'Federico Valverde', country: 'Uruguay' },
  { name: 'Luis Díaz', country: 'Colombia' },
  { name: 'Jhon Durán', country: 'Colombia' },
];

export const GOLDEN_GLOVE_PLAYERS: WCPlayer[] = [
  { name: 'Emiliano Martínez', country: 'Argentina' },
  { name: 'Alisson', country: 'Brazil' },
  { name: 'Ederson', country: 'Brazil' },
  { name: 'Thibaut Courtois', country: 'Belgium' },
  { name: 'Dominik Livaković', country: 'Croatia' },
  { name: 'Jordan Pickford', country: 'England' },
  { name: 'Mike Maignan', country: 'France' },
  { name: 'Manuel Neuer', country: 'Germany' },
  { name: 'Gianluigi Donnarumma', country: 'Italy' },
  { name: 'Guillermo Ochoa', country: 'Mexico' },
  { name: 'Yassine Bounou', country: 'Morocco' },
  { name: 'André Onana', country: 'Cameroon' },
  { name: 'Diogo Costa', country: 'Portugal' },
  { name: 'David Raya', country: 'Spain' },
  { name: 'Unai Simón', country: 'Spain' },
  { name: 'Gregor Kobel', country: 'Switzerland' },
  { name: 'Matt Turner', country: 'USA' },
  { name: 'Weverton', country: 'Brazil' },
];
